import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {HeaderTopComponent} from "./header-top.component";
import {RouterModule} from "@angular/router";
import {NotificationsComponent} from "../notifications/notifications.component";


@NgModule({
   declarations: [
      HeaderTopComponent
   ],
   exports:[
      HeaderTopComponent
   ],
    imports: [
        CommonModule,
        RouterModule,
        NotificationsComponent
    ]
})
export class HeaderTopModule { }
